import React, { useContext } from 'react';
import BookmarkContext from './context/BookmarkContext';
import { useNavigate } from 'react-router-dom';

const Landing = () => {
    const {
        handleClearComponent
    } = useContext(BookmarkContext);

    const navigate = useNavigate();

    return (
        <div className="bg-transparent">
            {/* Hero Section */}
            <section className="bg-gradient-left-right text-white py-1 text-center">
                <h1 className="display-4 font-weight-bold mb-4">
                    Welcome to the Bookmark App
                </h1>
                <p className="lead mb-4">
                    Securely store and organize your bookmarks, access them anytime from anywhere.
                </p>
                <div className="d-flex justify-content-center gap-4">
                    {
                        localStorage.getItem("User") ?
                            <>
                                <button
                                    type="button"
                                    onClick={() => {
                                        navigate('/bookmark');
                                    }}
                                    className="btn btn-light btn-lg px-4 py-3 rounded-pill"
                                >
                                    Dashboard
                                </button>
                            </> :
                            <>
                                <button
                                    type="button"
                                    onClick={() => {
                                        handleClearComponent();
                                        navigate('/login');
                                    }}
                                    className="btn btn-light btn-lg px-4 py-3 rounded-pill"
                                >
                                    Login
                                </button>

                                <button
                                    type="button"
                                    onClick={() => {
                                        handleClearComponent();
                                        navigate("/signup");
                                    }}
                                    className="btn btn-outline-light btn-lg px-4 py-3 rounded-pill"
                                >
                                    Sign Up
                                </button>
                            </>
                    }

                </div>
            </section>

            {/* Features Section */}
            <section className="py-5 bg-gradient-left-right text-center">
                <h2 className="display-4 text-white mb-5">Why Choose Bookmark?</h2>
                <div className="container">
                    <div className="row row-cols-1 row-cols-md-2 row-cols-lg-3 g-4">
                        <div className="col">
                            <div className="card shadow-sm border-0 rounded-lg">
                                <div className="card-body">
                                    <h5 className="card-title text-primary">End-to-End Encryption</h5>
                                    <p className="card-text text-muted">
                                        Your bookmarks are secured with encryption, ensuring your privacy.
                                    </p>
                                </div>
                            </div>
                        </div>
                        <div className="col">
                            <div className="card shadow-sm border-0 rounded-lg">
                                <div className="card-body">
                                    <h5 className="card-title text-primary">Easy Organization</h5>
                                    <p className="card-text text-muted">
                                        Categorize your bookmarks into folders and access them easily.
                                    </p>
                                </div>
                            </div>
                        </div>
                        <div className="col">
                            <div className="card shadow-sm border-0 rounded-lg">
                                <div className="card-body">
                                    <h5 className="card-title text-primary">Access Anywhere</h5>
                                    <p className="card-text text-muted">
                                        Access your bookmarks from any device, anywhere in the world.
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </div>

    );
};

export default Landing;
